(function () {
  'use strict';

  function initAscendLaunch(root) {
    if (!root || root.dataset.ascendInitialized === 'true') return;
    root.dataset.ascendInitialized = 'true';

    var nav = root.querySelector('[data-ascend-nav]');
    var heroSentinel = root.querySelector('[data-ascend-hero-sentinel]');
    var popupOpenBtns = root.querySelectorAll('[data-ascend-popup-open]');
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var formId = root.getAttribute('data-omnisend-form-id');
    var popupEnabled = root.getAttribute('data-popup-enable') === 'true';
    var autoEnabled = root.getAttribute('data-popup-auto-enable') === 'true';
    var autoDelay = parseInt(root.getAttribute('data-popup-auto-delay'), 10);
    if (isNaN(autoDelay) || autoDelay < 0) autoDelay = 7;

    var autoPopupTimer = null;
    var mysteryTimer = null;

    /* ---------- Nav scroll state ---------- */
    if (nav && heroSentinel && 'IntersectionObserver' in window) {
      var navObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              nav.classList.remove('is-scrolled');
            } else {
              nav.classList.add('is-scrolled');
            }
          });
        },
        { root: null, threshold: 0, rootMargin: '-70px 0px 0px 0px' }
      );
      navObserver.observe(heroSentinel);
    }

    /*
      ---------- Mystery countdown digits ----------
      Purely decorative (aria-hidden): each digit chip quietly reshuffles
      to a fresh "?" on a random interval, giving the topbar a bit of
      life without pretending to count down to a real moment. One digit
      rolls at a time so it stays subtle rather than flashing all eight
      at once.
    */
    var timerRoot = root.querySelector('[data-ascend-timer]');
    if (timerRoot && !prefersReduced) {
      var digitEls = Array.prototype.slice.call(timerRoot.querySelectorAll('[data-timer-digit]'));

      function rollOneDigit() {
        if (!digitEls.length) return;
        var el = digitEls[Math.floor(Math.random() * digitEls.length)];
        var current = el.querySelector('.ascend-launch__timer-digit-inner');
        if (!current) return;

        var next = document.createElement('span');
        next.className = 'ascend-launch__timer-digit-inner ascend-launch__timer-digit-inner--enter';
        next.textContent = '?';
        el.appendChild(next);

        requestAnimationFrame(function () {
          current.classList.add('ascend-launch__timer-digit-inner--exit');
          requestAnimationFrame(function () {
            next.classList.add('ascend-launch__timer-digit-inner--active');
          });
        });

        window.setTimeout(function () {
          if (current.parentNode) current.parentNode.removeChild(current);
        }, 520);
      }

      (function scheduleMysteryRoll() {
        var delay = 700 + Math.random() * 1600;
        mysteryTimer = window.setTimeout(function () {
          rollOneDigit();
          scheduleMysteryRoll();
        }, delay);
      })();
    }

    /*
      ---------- Real Omnisend popup ----------
      The signup modal itself (dark theme, email + phone fields, SMS/email
      consent checkboxes, success screen, Welcome Automation trigger) is
      hosted and rendered entirely by Omnisend, configured to match the
      ASCEND brand reference. This just opens it — there is no local
      modal, no placeholder form, and no fake success state here.
      Omnisend's own script also remembers dismissals across visits.
    */
    function openSignup() {
      if (!formId) {
        console.warn('ASCEND: no Omnisend form ID configured for this section.');
        return;
      }
      if (typeof window.omnisend === 'undefined' || Array.isArray(window.omnisend)) {
        console.warn('ASCEND: Omnisend\'s script does not appear to be loaded on this page yet.');
      }
      window.omnisend = window.omnisend || [];
      window.omnisend.push(['openForm', formId]);
    }

    popupOpenBtns.forEach(function (btn) {
      btn.addEventListener('click', openSignup);
    });

    if (popupEnabled && autoEnabled) {
      autoPopupTimer = window.setTimeout(openSignup, autoDelay * 1000);
    }

    root.__ascendCleanup = function () {
      if (autoPopupTimer) window.clearTimeout(autoPopupTimer);
      if (mysteryTimer) window.clearTimeout(mysteryTimer);
    };
  }

  function initAll() {
    document.querySelectorAll('[data-ascend-launch]').forEach(function (root) {
      initAscendLaunch(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme Editor: re-init cleanly when this section is reloaded */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ascend-launch]');
    if (root) {
      delete root.dataset.ascendInitialized;
      initAscendLaunch(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-ascend-launch]');
    if (root && typeof root.__ascendCleanup === 'function') {
      root.__ascendCleanup();
    }
  });
})();
